import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";

import React, { useEffect, useState } from "react";
import API from "./axiosInstance";
import "./AdminPanel.css";
import AdminCoupons from "./AdminCoupons";

function AdminPanel() {
  const [products, setProducts] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [editingProduct, setEditingProduct] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);
  const [search, setSearch] = useState("");
  const [activeView, setActiveView] = useState("products");
const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    category: "",
    description: "",
    images: "",
    price: "",
    quantity: 0,
    discount: 0,
  });

  // ================= AUTH =================
  useEffect(() => {
  const token = localStorage.getItem("adminToken");
  if (!token) {
    navigate("/admin/login");
    return;
  }
  fetchProducts();
}, [navigate]);


  // ================= FETCH =================
  const fetchProducts = async () => {
    try {
      const res = await API.get("/products");
      setProducts(res.data);
      setFiltered(res.data);
    } catch {
      alert("Error fetching products");
    }
  };

  // ================= SEARCH =================
  const handleSearch = (value) => {
    setSearch(value);
    if (!value.trim()) {
      setFiltered(products);
      return;
    }
    const lower = value.toLowerCase();
    setFiltered(
      products.filter(
        (p) =>
          p.name.toLowerCase().includes(lower) ||
          p.category.toLowerCase().includes(lower)
      )
    );
  };

  // ================= SUBMIT =================
  const handleSubmit = async (e) => {
    e.preventDefault();
    const imageArray = formData.images
      ? formData.images.split(",").map((i) => i.trim())
      : [];

    try {
      if (editingProduct) {
        await API.put(`/products/${editingProduct.id}`, {
          ...formData,
          images: imageArray,
        });
        alert("✅ Product Updated");
      } else {
        await API.post("/products/add", {
          ...formData,
          images: imageArray,
        });
        alert("✅ Product Added");
      }
      resetForm();
      fetchProducts();
      setActiveView("products");
    } catch {
      alert("❌ Error saving product");
    }
  };

  // ================= DELETE =================
  const handleDelete = async (id) => {
    if (!window.confirm("Delete this product?")) return;
    try {
      await API.delete(`/products/${id}`);
      fetchProducts();
    } catch {
      alert("Delete failed");
    }
  };

  // ================= RESET =================
  const resetForm = () => {
    setFormData({
      name: "",
      category: "",
      description: "",
      images: "",
      price: "",
      quantity: 0,
      discount: 0,
    });
    setEditingProduct(null);
  };

  // ================= EDIT PRODUCT =================
  const handleEditClick = (product) => {
    setEditingProduct(product);
    setFormData({
      name: product.name,
      category: product.category,
      description: product.description,
      images: product.images.join(", "),
      price: product.price,
      quantity: product.quantity,
      discount: product.discount,
    });
    setActiveView("add");
  };

  return (
    <div className="admin-container">
      {/* ========== TOP NAVIGATION BAR (replaces sidebar) ========== */}
      <header className="topbar">
        <div className="topbar-logo">KingShop</div>
        <nav className="topbar-nav">
          <button
            className={`topbar-item ${activeView === "products" ? "active" : ""}`}
            onClick={() => setActiveView("products")}
          >
            📋 Product List
          </button>
          <button
            className={`topbar-item ${activeView === "add" ? "active" : ""}`}
            onClick={() => {
              resetForm();
              setActiveView("add");
            }}
          >
            ➕ Add Product
          </button>
          <button
            className={`topbar-item ${activeView === "coupons" ? "active" : ""}`}
            onClick={() => setActiveView("coupons")}
          >
            🎟 Coupons
          </button>
         <Link to="/admin/orders" className="topbar-item">
  🛒 Orders
</Link>

         <button
  className="topbar-item logout"
  onClick={() => {
    localStorage.removeItem("adminToken");
    navigate("/admin/login");
  }}
>
  🚪 Logout
</button>

        </nav>
      </header>

      {/* ========== MAIN CONTENT ========== */}
      <div className="main-content">
        <h1 className="title">Admin Dashboard</h1>

        {/* Coupons view */}
        {activeView === "coupons" && <AdminCoupons />}

        {/* Add/Edit Product Form */}
        {activeView === "add" && (
          <div className="card form-card">
            <h2>{editingProduct ? "Edit Product" : "Add Product"}</h2>
            <form onSubmit={handleSubmit}>
              <input
                placeholder="Name"
                value={formData.name}
                onChange={(e) =>
                  setFormData({ ...formData, name: e.target.value })
                }
                required
              />
              <input
                placeholder="Category"
                value={formData.category}
                onChange={(e) =>
                  setFormData({ ...formData, category: e.target.value })
                }
                required
              />
              <textarea
                placeholder="Description"
                value={formData.description}
                onChange={(e) =>
                  setFormData({ ...formData, description: e.target.value })
                }
                required
              />
              <input
                placeholder="Image URLs (comma separated)"
                value={formData.images}
                onChange={(e) =>
                  setFormData({ ...formData, images: e.target.value })
                }
              />
              <input
                type="number"
                placeholder="Price"
                value={formData.price}
                onChange={(e) =>
                  setFormData({ ...formData, price: e.target.value })
                }
                required
                min="0"
              />
              <input
                type="number"
                placeholder="Quantity"
                value={formData.quantity}
                onChange={(e) =>
                  setFormData({ ...formData, quantity: e.target.value })
                }
                required
                min="0"
              />
              <input
                type="number"
                placeholder="Discount (%)"
                value={formData.discount}
                onChange={(e) =>
                  setFormData({ ...formData, discount: e.target.value })
                }
                min="0"
                max="100"
              />
              {formData.price && (
                <p style={{ fontSize: 14 }}>
                  Final Price: ₹
                  {Math.round(
                    formData.price - (formData.price * formData.discount) / 100
                  )}
                </p>
              )}
              <button type="submit" className="btn-primary">
                {editingProduct ? "Update" : "Add"}
              </button>
              <button
                type="button"
                onClick={() => {
                  resetForm();
                  setActiveView("products");
                }}
                className="btn-secondary"
              >
                Cancel
              </button>
            </form>
          </div>
        )}

        {/* Product List */}
        {activeView === "products" && (
          <>
            <div className="search-container">
              <input
                className="search-box"
                placeholder="🔍 Search product..."
                value={search}
                onChange={(e) => handleSearch(e.target.value)}
              />
            </div>

            <div className="product-grid">
              {filtered.length > 0 ? (
                filtered.map((p) => {
                  const finalPrice =
                    p.discount > 0
                      ? Math.round(p.price - (p.price * p.discount) / 100)
                      : p.price;

                  return (
                    <div key={p.id} className="card product-card">
                      <img
                        src={p.images[0]}
                        className="product-img"
                        alt=""
                        onClick={() => setPreviewImage(p.images[0])}
                      />
                      <h3>{p.name}</h3>
                      <p>₹{finalPrice}</p>
                      <p style={{ fontSize: 13 }}>
                        Discount: {p.discount}% <br />
                        Stock:{" "}
                        {p.quantity <= 0 ? (
                          <span style={{ color: "red" }}>Out of Stock</span>
                        ) : p.quantity < 5 ? (
                          <span style={{ color: "orange" }}>
                            ⚠ Low ({p.quantity})
                          </span>
                        ) : (
                          <span style={{ color: "green" }}>
                            {p.quantity} Available
                          </span>
                        )}
                      </p>
                      <div className="actions">
                        <button
                          className="btn-edit"
                          onClick={() => handleEditClick(p)}
                        >
                          Edit
                        </button>
                        <button
                          className="btn-delete"
                          onClick={() => handleDelete(p.id)}
                        >
                          Delete
                        </button>
                      </div>
                    </div>
                  );
                })
              ) : (
                <div className="no-products">
                  <p>
                    No products found.{" "}
                    {search && "Try a different search term."}
                  </p>
                  <button
                    className="btn-primary"
                    onClick={() => {
                      resetForm();
                      setActiveView("add");
                    }}
                  >
                    ➕ Add Your First Product
                  </button>
                </div>
              )}
            </div>
          </>
        )}
      </div>

      {/* Image Preview Modal */}
      {previewImage && (
        <div className="modal" onClick={() => setPreviewImage(null)}>
          <img src={previewImage} className="modal-img" alt="" />
        </div>
      )}
    </div>
  );
}

export default AdminPanel;